import { useBlogArticleList } from '@/services/query/article.query';
import { ArticleListProps } from '@/services/types/article.type';
import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';

export interface BlogListContainerProps {
  limit?: number;
  render: (props: ArticleListProps) => React.ReactNode;
}

export function BlogListContainer({ limit, render }: BlogListContainerProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // URL에서 페이지 파라미터 가져오기 (기본값: 1)
  const initialPage = parseInt(searchParams.get('page') || '1', 10);
  const [page, setPage] = useState(initialPage);

  // 실제 데이터 패칭 로직
  const { data, isLoading, error } = useBlogArticleList({ page, limit });

  // 페이지 변경 핸들러
  const handlePageChange = (newPage: number) => {
    setPage(newPage);

    // URL 업데이트
    const params = new URLSearchParams(searchParams.toString());
    if (newPage === 1) {
      params.delete('page'); // 1페이지일 때는 쿼리 파라미터 제거
    } else {
      params.set('page', newPage.toString());
    }

    const newUrl = params.toString() ? `?${params.toString()}` : '';
    router.replace(newUrl, { scroll: false });
  };

  const articles = data?.data.articles ?? [];
  const totalCount = data?.data.totalCount ?? 0;
  const totalPages = limit && limit > 0 ? Math.ceil(totalCount / limit) : 0;

  // console.log('headerItem:', headerItem?.title);
  // console.log(
  //   'current items:',
  //   articles.map((item) => item.title),
  // );

  if (isLoading) return <div>로딩중...</div>;
  if (error) return <div>에러 발생!</div>;

  return (
    <section className="desktop:flex justify-center">
      <div className="desktop:web-w desktop:w-full">
        {render({
          items: articles,
          page,
          totalPages,
          onPageChange: handlePageChange,
        })}
      </div>
    </section>
  );
}
